/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect'

export const selectPicture = createSelector(
	(state) => state.main,
	(main) => main.user.picture || '',
)
